const cyclicVoltaJcamp2 = `
##TITLE=Cyclic Voltammetry
##JCAMP-DX=5.00 $$ chemotion-converter-app (0.1.0)
##DATA TYPE=CYCLIC VOLTAMMETRY
##DATA CLASS=XYDATA
##ORIGIN=
##OWNER=
##XUNITS=V vs Ref
##YUNITS=Ampere
##TYPE=PalmSens.DataFiles.SessionFile
##TIMESTEP=636506816837276482
##DEVICEUSED=6
##DEVICESERIAL=ES3 16X965
##FIRSTX=4.99413E-05
##LASTX=-0.00994404
##MINX=-1.80885
##MAXX=1.80895
##MINY=-3.3747399999999995e-05
##MAXY=0.00023741
##NPOINTS=724
##FIRSTY=5.86572e-07
##XUNITS=V vs Ref
##YUNITS=Ampere
##XYDATA=(XY..XY)
4.99413E-05, 5.86572e-07
0.0100439, 4.3969399999999994e-07
0.0200379, 4.02193e-07
0.0300315, 3.9469199999999995e-07
0.0400255, 4.02193e-07
0.0500195, 4.1406900000000003e-07
0.0600134, 4.29038e-07
0.0700074, 4.5066299999999996e-07
0.080001, 4.70726e-07
0.089995, 4.90226e-07
0.099989, 5.15789e-07
0.109983, 5.40727e-07
0.119977, 5.65977e-07
0.129971, 5.9229e-07
0.139964, 6.197279999999999e-07
0.149958, 6.484159999999999e-07
0.159952, 6.754159999999999e-07
0.169946, 7.01042e-07
0.17994, 7.322920000000001e-07
0.189934, 7.619179999999999e-07
0.199928, 7.907309999999999e-07
0.209922, 8.226059999999999e-07
0.219916, 8.53669e-07
0.22991, 8.83607e-07
0.239904, 9.15545e-07
0.249897, 9.45296e-07
0.259891, 9.79109e-07
0.269885, 1.0087999999999998e-06
0.279879, 1.04255e-06
0.289873, 1.0746699999999999e-06
0.299867, 1.11274e-06
0.309861, 1.1463000000000001e-06
0.319855, 1.18217e-06
0.329849, 1.22136e-06
0.339843, 1.2639299999999999e-06
0.349837, 1.30699e-06
0.35983, 1.35524e-06
0.369824, 1.40487e-06
0.379818, 1.46218e-06
0.389812, 1.5201199999999998e-06
0.399806, 1.58168e-06
0.4098, 1.65034e-06
0.419794, 1.7234599999999998e-06
0.429788, 1.79722e-06
0.439782, 1.87472e-06
0.449776, 1.95284e-06
0.45977, 2.0359699999999997e-06
0.469764, 2.1209699999999997e-06
0.479757, 2.20847e-06
0.489751, 2.3016e-06
0.499745, 2.39847e-06
0.509739, 2.5066e-06
0.519733, 2.6265999999999996e-06
0.529727, 2.7609799999999998e-06
0.539721, 2.9134799999999996e-06
0.549715, 3.08473e-06
0.559709, 3.28474e-06
0.569703, 3.51662e-06
0.579696, 3.7909999999999998e-06
0.58969, 4.0935e-06
0.599684, 4.47663e-06
0.609678, 4.922889999999999e-06
0.619672, 5.459769999999999e-06
0.629666, 6.10353e-06
0.63966, 6.88604e-06
0.649654, 7.83543e-06
0.659648, 9.00608e-06
0.669642, 1.0434799999999999e-05
0.679635, 1.2201099999999999e-05
0.689629, 1.43724e-05
0.699623, 1.70431e-05
0.709617, 2.03097e-05
0.719611, 2.43035e-05
0.729605, 2.9109799999999997e-05
0.739599, 3.4872399999999995e-05
0.749593, 4.16788e-05
0.759587, 4.9660099999999996e-05
0.769581, 5.88853e-05
0.779574, 6.94042e-05
0.789568, 8.093559999999998e-05
0.799562, 9.359829999999999e-05
0.809556, 0.00010712399999999999
0.81955, 0.00012136099999999999
0.829544, 0.000136074
0.839538, 0.000150955
0.849532, 0.00016568100000000002
0.859526, 0.000180159
0.86952, 0.000193597
0.879513, 0.000206097
0.889507, 0.000216972
0.899501, 0.00022590999999999998
0.909495, 0.000232472
0.919489, 0.00023641
0.929483, 0.00023741
0.939477, 0.000235347
0.949471, 0.00023066
0.959465, 0.000223722
0.969459, 0.00021565999999999998
0.979453, 0.000207097
0.989446, 0.000198722
0.99944, 0.000190784
1.00943, 0.000183722
1.01943, 0.00017709599999999999
1.02942, 0.000171159
1.03942, 0.000165971
1.04941, 0.000160909
1.0594, 0.00015647099999999999
1.0694, 0.000152409
1.07939, 0.000148721
1.08939, 0.00014522099999999998
1.09938, 0.000142096
1.10937, 0.00013915799999999998
1.11937, 0.000136221
1.12936, 0.000133471
1.13935, 0.000131221
1.14935, 0.000128971
1.15934, 0.000126533
1.16934, 0.000124783
1.17933, 0.000122783
1.18932, 0.00012103299999999999
1.19932, 0.00011921999999999999
1.20931, 0.000117471
1.21931, 0.000116158
1.2293, 0.00011428299999999999
1.23929, 0.00011321999999999999
1.24929, 0.00011146999999999999
1.25928, 0.000110283
1.26928, 0.000109221
1.27927, 0.00010809499999999999
1.28926, 0.000106908
1.29926, 0.000105658
1.30925, 0.00010434499999999999
1.31925, 0.000103345
1.32924, 0.000102345
1.33923, 0.000101283
1.34923, 0.00010034499999999999
1.35922, 9.94077e-05
1.36921, 9.865779999999999e-05
1.37921, 9.803270000000001e-05
1.3892, 9.72202e-05
1.3992, 9.62827e-05
1.40919, 9.528279999999999e-05
1.41918, 9.447029999999999e-05
1.42918, 9.41577e-05
1.43917, 9.32827e-05
1.44917, 9.23452e-05
1.45916, 9.20327e-05
1.46915, 9.12201e-05
1.47915, 9.02827e-05
1.48914, 8.972e-05
1.49914, 8.92825e-05
1.50913, 8.847e-05
1.51912, 8.81577e-05
1.52912, 8.734509999999999e-05
1.53911, 8.70326e-05
1.5491, 8.628249999999999e-05
1.5591, 8.56576e-05
1.56909, 8.52826e-05
1.57909, 8.47201e-05
1.58908, 8.428259999999999e-05
1.59907, 8.39701e-05
1.60907, 8.32825e-05
1.61906, 8.30326e-05
1.62906, 8.228249999999999e-05
1.63905, 8.21574e-05
1.64904, 8.13451e-05
1.65904, 8.11574e-05
1.66903, 8.028239999999999e-05
1.67903, 8.028239999999999e-05
1.68902, 7.95324e-05
1.69901, 7.92825e-05
1.70901, 7.90949e-05
1.719, 7.840749999999999e-05
1.729, 7.82824e-05
1.73899, 7.771989999999999e-05
1.74898, 7.734489999999999e-05
1.75898, 7.722e-05
1.76897, 7.69699e-05
1.77896, 7.62825e-05
1.78896, 7.62198e-05
1.79895, 7.578230000000001e-05
1.80895, 7.528230000000001e-05
1.79895, 7.428239999999999e-05
1.78896, 7.32822e-05
1.77896, 7.303239999999999e-05
1.76897, 7.221980000000001e-05
1.75898, 7.17824e-05
1.74898, 7.128239999999999e-05
1.73899, 7.09698e-05
1.729, 7.02822e-05
1.719, 7.01573e-05
1.70901, 6.934480000000001e-05
1.69901, 6.92823e-05
1.68902, 6.884480000000001e-05
1.67903, 6.82824e-05
1.66903, 6.82197e-05
1.65904, 6.75323e-05
1.64904, 6.72822e-05
1.63905, 6.71573e-05
1.62906, 6.659480000000001e-05
1.61906, 6.628230000000001e-05
1.60907, 6.61573e-05
1.59907, 6.57198e-05
1.58908, 6.528230000000001e-05
1.57909, 6.52196e-05
1.56909, 6.484459999999999e-05
1.5591, 6.43446e-05
1.5491, 6.42197e-05
1.53911, 6.41572e-05
1.52912, 6.35321e-05
1.51912, 6.32823e-05
1.50913, 6.32198e-05
1.49914, 6.30322e-05
1.48914, 6.23448e-05
1.47915, 6.228209999999999e-05
1.46915, 6.22196e-05
1.45916, 6.196979999999999e-05
1.44917, 6.14071e-05
1.43917, 6.12822e-05
1.42918, 6.12197e-05
1.41918, 6.07822e-05
1.40919, 6.03447e-05
1.3992, 6.0282200000000004e-05
1.3892, 6.0219799999999996e-05
1.37921, 5.99697e-05
1.36921, 5.94072e-05
1.35922, 5.92821e-05
1.34923, 5.92196e-05
1.33923, 5.9157099999999996e-05
1.32924, 5.87196e-05
1.31925, 5.83446e-05
1.30925, 5.8282099999999995e-05
1.29926, 5.82197e-05
1.28926, 5.78446e-05
1.27927, 5.759449999999999e-05
1.26928, 5.72822e-05
1.25928, 5.7219499999999997e-05
1.24929, 5.7219499999999997e-05
1.23929, 5.69696e-05
1.2293, 5.65321e-05
1.21931, 5.6281999999999994e-05
1.20931, 5.6281999999999994e-05
1.19932, 5.61571e-05
1.18932, 5.590699999999999e-05
1.17933, 5.5469499999999995e-05
1.16934, 5.52821e-05
1.15934, 5.52821e-05
1.14935, 5.52197e-05
1.13935, 5.503199999999999e-05
1.12936, 5.4594499999999994e-05
1.11937, 5.43447e-05
1.10937, 5.42819e-05
1.09938, 5.421949999999999e-05
1.08939, 5.39696e-05
1.07939, 5.3532099999999995e-05
1.0694, 5.3281999999999996e-05
1.0594, 5.3219599999999994e-05
1.04941, 5.30946e-05
1.03942, 5.23446e-05
1.02942, 5.22821e-05
1.01943, 5.1844599999999995e-05
1.00943, 5.12819e-05
0.99944, 5.1032099999999995e-05
0.989446, 5.0282e-05
0.979453, 4.978199999999999e-05
0.969459, 4.88914e-05
0.959465, 4.80351e-05
0.949471, 4.7085099999999994e-05
0.939477, 4.5960099999999994e-05
0.929483, 4.4609999999999995e-05
0.919489, 4.31163e-05
0.909495, 4.14288e-05
0.899501, 3.95475e-05
0.889507, 3.75412e-05
0.879513, 3.5428699999999995e-05
0.86952, 3.32661e-05
0.859526, 3.11599e-05
0.849532, 2.9116099999999997e-05
0.839538, 2.72098e-05
0.829544, 2.5497299999999997e-05
0.81955, 2.40098e-05
0.809556, 2.2759699999999998e-05
0.799562, 2.1740999999999997e-05
0.789568, 2.09159e-05
0.779574, 2.02972e-05
0.769581, 1.9815899999999998e-05
0.759587, 1.94784e-05
0.749593, 1.92222e-05
0.739599, 1.9022200000000002e-05
0.729605, 1.89034e-05
0.719611, 1.8809699999999997e-05
0.709617, 1.87222e-05
0.699623, 1.86222e-05
0.689629, 1.85284e-05
0.679635, 1.8428399999999998e-05
0.669642, 1.82909e-05
0.659648, 1.80909e-05
0.649654, 1.78159e-05
0.63966, 1.7453399999999998e-05
0.629666, 1.7009599999999997e-05
0.619672, 1.64096e-05
0.609678, 1.56346e-05
0.599684, 1.4715799999999999e-05
0.58969, 1.36221e-05
0.579696, 1.23846e-05
0.569703, 1.1022e-05
0.559709, 9.61578e-06
0.549715, 8.19075e-06
0.539721, 6.85322e-06
0.529727, 5.64072e-06
0.519733, 4.596949999999999e-06
0.509739, 3.7156799999999997e-06
0.499745, 2.9719099999999997e-06
0.489751, 2.40316e-06
0.479757, 1.91565e-06
0.469764, 1.54221e-06
0.45977, 1.19846e-06
0.449776, 8.89702e-07
0.439782, 6.04696e-07
0.429788, 3.43442e-07
0.419794, 1.05939e-07
0.4098, -1.00939e-07
0.399806, -2.79067e-07
0.389812, -4.2969499999999996e-07
0.379818, -5.551019999999999e-07
0.369824, -6.542289999999999e-07
0.35983, -7.343549999999999e-07
0.349837, -7.97918e-07
0.339843, -8.481070000000001e-07
0.329849, -8.871069999999999e-07
0.319855, -9.1967e-07
0.309861, -9.464829999999999e-07
0.299867, -9.66296e-07
0.289873, -9.86546e-07
0.279879, -1.0041699999999999e-06
0.269885, -1.0193000000000001e-06
0.259891, -1.0360499999999998e-06
0.249897, -1.0492999999999998e-06
0.239904, -1.06336e-06
0.22991, -1.0771099999999999e-06
0.219916, -1.0921700000000001e-06
0.209922, -1.10661e-06
0.199928, -1.12161e-06
0.189934, -1.13399e-06
0.17994, -1.15186e-06
0.169946, -1.16811e-06
0.159952, -1.18486e-06
0.149958, -1.19974e-06
0.139964, -1.22005e-06
0.129971, -1.23743e-06
0.119977, -1.2571099999999999e-06
0.109983, -1.2759899999999999e-06
0.099989, -1.29474e-06
0.089995, -1.3123e-06
0.080001, -1.3334299999999998e-06
0.0700074, -1.3532399999999999e-06
0.0600134, -1.3737999999999999e-06
0.0500195, -1.39362e-06
0.0400255, -1.41512e-06
0.0300315, -1.4342999999999998e-06
0.0200379, -1.4576800000000001e-06
0.0100439, -1.47468e-06
4.99413E-05, -1.49574e-06
-0.00994404, -1.51518e-06
-0.019938, -1.5376199999999998e-06
-0.0299316, -1.5598700000000001e-06
-0.0399256, -1.57974e-06
-0.0499196, -1.60437e-06
-0.0599135, -1.62612e-06
-0.0699075, -1.65106e-06
-0.0799013, -1.67656e-06
-0.0898951, -1.69596e-06
-0.0998891, -1.71846e-06
-0.109883, -1.73659e-06
-0.119877, -1.7553399999999998e-06
-0.129871, -1.7697099999999998e-06
-0.139865, -1.7859599999999999e-06
-0.149859, -1.8009699999999998e-06
-0.159853, -1.8184599999999998e-06
-0.169846, -1.83347e-06
-0.17984, -1.85159e-06
-0.189834, -1.8647199999999998e-06
-0.199828, -1.88284e-06
-0.209822, -1.90097e-06
-0.219816, -1.9165899999999997e-06
-0.22981, -1.93159e-06
-0.239804, -1.95034e-06
-0.249798, -1.96597e-06
-0.259792, -1.98347e-06
-0.269785, -1.99972e-06
-0.279779, -2.0203399999999998e-06
-0.289773, -2.0334699999999997e-06
-0.299767, -2.0528400000000003e-06
-0.309761, -2.0697199999999996e-06
-0.319755, -2.08722e-06
-0.329749, -2.10347e-06
-0.339743, -2.12472e-06
-0.349737, -2.13972e-06
-0.359731, -2.16222e-06
-0.369724, -2.1809699999999996e-06
-0.379718, -2.20285e-06
-0.389712, -2.2247199999999998e-06
-0.399706, -2.2459699999999998e-06
-0.4097, -2.2678500000000002e-06
-0.419694, -2.29347e-06
-0.429688, -2.31847e-06
-0.439682, -2.34472e-06
-0.449676, -2.36847e-06
-0.45967, -2.39847e-06
-0.469663, -2.4241000000000002e-06
-0.479657, -2.45535e-06
-0.489651, -2.48285e-06
-0.499645, -2.5190999999999997e-06
-0.509639, -2.5528499999999996e-06
-0.519633, -2.5959799999999997e-06
-0.529627, -2.6359799999999997e-06
-0.539621, -2.6859799999999997e-06
-0.549615, -2.7366e-06
-0.559609, -2.80473e-06
-0.569602, -2.8734799999999995e-06
-0.579596, -2.9597299999999998e-06
-0.58959, -3.05598e-06
-0.599584, -3.17411e-06
-0.609578, -3.30974e-06
-0.619572, -3.47037e-06
-0.629566, -3.6553699999999998e-06
-0.63956, -3.8635e-06
-0.649554, -4.09163e-06
-0.659548, -4.33975e-06
-0.669541, -4.59038e-06
-0.679535, -4.8397599999999996e-06
-0.689529, -5.062269999999999e-06
-0.699523, -5.2535199999999995e-06
-0.709517, -5.4004e-06
-0.719511, -5.5029e-06
-0.729505, -5.55727e-06
-0.739499, -5.58352e-06
-0.749493, -5.58227e-06
-0.759487, -5.57415e-06
-0.769481, -5.5666499999999995e-06
-0.779474, -5.56977e-06
-0.789468, -5.58852e-06
-0.799462, -5.62852e-06
-0.809456, -5.692899999999999e-06
-0.81945, -5.78415e-06
-0.829444, -5.8954e-06
-0.839438, -6.0285299999999995e-06
-0.849432, -6.1716599999999995e-06
-0.859426, -6.3247799999999994e-06
-0.86942, -6.4691599999999996e-06
-0.879413, -6.59729e-06
-0.889407, -6.70479e-06
-0.899401, -6.79792e-06
-0.909395, -6.8779199999999995e-06
-0.919389, -6.96354e-06
-0.929383, -7.0598e-06
-0.939377, -7.173549999999999e-06
-0.949371, -7.31043e-06
-0.959365, -7.464179999999999e-06
-0.969359, -7.6197999999999994e-06
-0.979353, -7.77543e-06
-0.989347, -7.90543e-06
-0.99934, -8.002309999999999e-06
-1.00933, -8.05481e-06
-1.01933, -8.06794e-06
-1.02932, -8.051059999999999e-06
-1.03932, -8.02106e-06
-1.04931, -7.98293e-06
-1.0593, -7.95856e-06
-1.0693, -7.942929999999999e-06
-1.07929, -7.939809999999999e-06
-1.08929, -7.951679999999999e-06
-1.09928, -7.97918e-06
-1.10927, -8.025439999999999e-06
-1.11927, -8.08356e-06
-1.12926, -8.152309999999999e-06
-1.13926, -8.241059999999999e-06
-1.14925, -8.34544e-06
-1.15924, -8.47169e-06
-1.16924, -8.61794e-06
-1.17923, -8.79732e-06
-1.18922, -8.99733e-06
-1.19922, -9.234199999999999e-06
-1.20921, -9.50483e-06
-1.21921, -9.82671e-06
-1.2292, -1.02005e-05
-1.23919, -1.06374e-05
-1.24919, -1.1151099999999999e-05
-1.25918, -1.17574e-05
-1.26918, -1.2458e-05
-1.27917, -1.3262399999999999e-05
-1.28916, -1.4168699999999999e-05
-1.29916, -1.52024e-05
-1.30915, -1.63868e-05
-1.31915, -1.77512e-05
-1.32914, -1.93159e-05
-1.33913, -2.1041e-05
-1.34913, -2.2884699999999998e-05
-1.35912, -2.4759799999999996e-05
-1.36911, -2.6515999999999998e-05
-1.37911, -2.80161e-05
-1.3891, -2.91911e-05
-1.3991, -3.00161e-05
-1.40909, -3.05786e-05
-1.41908, -3.1009899999999996e-05
-1.42908, -3.14286e-05
-1.43907, -3.19286e-05
-1.44907, -3.24599e-05
-1.45906, -3.30286e-05
-1.46905, -3.34849e-05
-1.47905, -3.37286e-05
-1.48904, -3.3747399999999995e-05
-1.49904, -3.35599e-05
-1.50903, -3.3228599999999996e-05
-1.51902, -3.28599e-05
-1.52902, -3.24974e-05
-1.53901, -3.21974e-05
-1.549, -3.19349e-05
-1.559, -3.17474e-05
-1.56899, -3.1584899999999996e-05
-1.57899, -3.14911e-05
-1.58898, -3.14411e-05
-1.59897, -3.14411e-05
-1.60897, -3.14661e-05
-1.61896, -3.15349e-05
-1.62896, -3.16286e-05
-1.63895, -3.17661e-05
-1.64894, -3.19099e-05
-1.65894, -3.20724e-05
-1.66893, -3.22349e-05
-1.67893, -3.2378599999999995e-05
-1.68892, -3.25161e-05
-1.69891, -3.26411e-05
-1.70891, -3.27474e-05
-1.7189, -3.28224e-05
-1.7289, -3.28786e-05
-1.73889, -3.29099e-05
-1.74888, -3.29161e-05
-1.75888, -3.29224e-05
-1.76887, -3.2897399999999994e-05
-1.77886, -3.28724e-05
-1.78886, -3.28474e-05
-1.79885, -3.28099e-05
-1.80885, -3.27786e-05
-1.79885, -2.93411e-05
-1.78886, -2.68535e-05
-1.77886, -2.49035e-05
-1.76887, -2.3341e-05
-1.75888, -2.20222e-05
-1.74888, -2.0890999999999997e-05
-1.73889, -1.9947199999999998e-05
-1.7289, -1.90847e-05
-1.7189, -1.83409e-05
-1.70891, -1.76721e-05
-1.69891, -1.70534e-05
-1.68892, -1.6484599999999998e-05
-1.67893, -1.59784e-05
-1.66893, -1.55096e-05
-1.65894, -1.50784e-05
-1.64894, -1.46783e-05
-1.63895, -1.4284599999999999e-05
-1.62896, -1.39596e-05
-1.61896, -1.3597099999999999e-05
-1.60897, -1.3284599999999998e-05
-1.59897, -1.29846e-05
-1.58898, -1.2722099999999998e-05
-1.57899, -1.2465799999999998e-05
-1.56899, -1.2184599999999999e-05
-1.559, -1.19471e-05
-1.549, -1.16783e-05
-1.53901, -1.14658e-05
-1.52902, -1.11783e-05
-1.51902, -1.09533e-05
-1.50903, -1.06908e-05
-1.49904, -1.0465799999999999e-05
-1.48904, -1.0184499999999999e-05
-1.47905, -9.89703e-06
-1.46905, -9.60952e-06
-1.45906, -9.29077e-06
-1.44907, -8.98452e-06
-1.43907, -8.64075e-06
-1.42908, -8.27825e-06
-1.41908, -7.896999999999999e-06
-1.40909, -7.5594899999999995e-06
-1.3991, -7.1782399999999996e-06
-1.3891, -6.778229999999999e-06
-1.37911, -6.37822e-06
-1.36911, -5.96572e-06
-1.35912, -5.51571e-06
-1.34913, -5.07821e-06
-1.33913, -4.596949999999999e-06
-1.32914, -4.1657e-06
-1.31915, -3.69694e-06
-1.30915, -3.28443e-06
-1.29916, -2.91848e-06
-1.28916, -2.57723e-06
-1.27917, -2.2722199999999997e-06
-1.26918, -2.00972e-06
-1.25918, -1.77846e-06
-1.24919, -1.58346e-06
-1.23919, -1.4147099999999998e-06
-1.2292, -1.27221e-06
-1.21921, -1.14846e-06
-1.20921, -1.0447e-06
-1.19922, -9.515769999999999e-07
-1.18922, -8.740759999999999e-07
-1.17923, -8.053259999999999e-07
-1.16924, -7.40324e-07
-1.15924, -6.865729999999999e-07
-1.14925, -6.378219999999999e-07
-1.13926, -5.915709999999999e-07
-1.12926, -5.503209999999999e-07
-1.11927, -5.07821e-07
-1.10927, -4.72195e-07
-1.09928, -4.3406999999999997e-07
-1.08929, -3.9969399999999995e-07
-1.07929, -3.6281799999999996e-07
-1.0693, -3.2719399999999996e-07
-1.0593, -2.9341099999999995e-07
-1.04931, -2.56348e-07
-1.03932, -2.17097e-07
-1.02932, -1.78659e-07
-1.01933, -1.36471e-07
-1.00933, -9.478269999999999e-08
-0.99934, -5.2719599999999996e-08
-0.989347, -1.32816e-08
-0.979353, 2.4844199999999998e-08
-0.969359, 6.046959999999999e-08
-0.959365, 9.67827e-08
-0.949371, 1.29971e-07
-0.939377, 1.6609599999999998e-07
-0.929383, 1.94784e-07
-0.919389, 2.2778499999999997e-07
-0.909395, 2.5728499999999996e-07
-0.899401, 2.88223e-07
-0.889407, 3.16724e-07
-0.879413, 3.44412e-07
-0.86942, 3.72474e-07
-0.859426, 4.036e-07
-0.849432, 4.2853799999999994e-07
-0.839438, 4.57351e-07
-0.829444, 4.84351e-07
-0.81945, 5.10102e-07
-0.809456, 5.36102e-07
-0.799462, 5.63665e-07
-0.789468, 5.904779999999999e-07
-0.779474, 6.15291e-07
-0.769481, 6.422909999999999e-07
-0.759487, 6.68854e-07
-0.749493, 6.93354e-07
-0.739499, 7.21605e-07
-0.729505, 7.45105e-07
-0.719511, 7.75606e-07
-0.709517, 8.003559999999999e-07
-0.699523, 8.29169e-07
-0.689529, 8.55357e-07
-0.679535, 8.852319999999999e-07
-0.669541, 9.1117e-07
-0.659548, 9.40858e-07
-0.649554, 9.68734e-07
-0.63956, 9.99922e-07
-0.629566, 1.02517e-06
-0.619572, 1.05686e-06
-0.609578, 1.08367e-06
-0.599584, 1.1148599999999999e-06
-0.58959, 1.14367e-06
-0.579596, 1.1753e-06
-0.569602, 1.2048e-06
-0.559609, 1.23455e-06
-0.549615, 1.26593e-06
-0.539621, 1.29743e-06
-0.529627, 1.3269899999999999e-06
-0.519633, 1.3585499999999999e-06
-0.509639, 1.3889899999999999e-06
-0.499645, 1.42105e-06
-0.489651, 1.4508e-06
-0.479657, 1.48212e-06
-0.469663, 1.51287e-06
-0.45967, 1.54437e-06
-0.449676, 1.57587e-06
-0.439682, 1.61159e-06
-0.429688, 1.6422099999999998e-06
-0.419694, 1.67534e-06
-0.4097, 1.70409e-06
-0.399706, 1.73721e-06
-0.389712, 1.7703399999999999e-06
-0.379718, 1.8022199999999998e-06
-0.369724, 1.83471e-06
-0.359731, 1.87097e-06
-0.349737, 1.90284e-06
-0.339743, 1.93659e-06
-0.329749, 1.9697199999999997e-06
-0.319755, 2.00659e-06
-0.309761, 2.04222e-06
-0.299767, 2.0784699999999997e-06
-0.289773, 2.1128399999999997e-06
-0.279779, 2.15097e-06
-0.269785, 2.1872199999999997e-06
-0.259792, 2.2272199999999997e-06
-0.249798, 2.2641e-06
-0.239804, 2.30535e-06
-0.22981, 2.34285e-06
-0.219816, 2.3822199999999995e-06
-0.209822, 2.42285e-06
-0.199828, 2.46285e-06
-0.189834, 2.5022199999999997e-06
-0.17984, 2.54473e-06
-0.169846, 2.58598e-06
-0.159853, 2.62848e-06
-0.149859, 2.6716e-06
-0.139865, 2.7166e-06
-0.129871, 2.7628499999999997e-06
-0.119877, 2.8116099999999998e-06
-0.109883, 2.86661e-06
-0.0998891, 2.92848e-06
-0.0898951, 3.00098e-06
-0.0799013, 3.08348e-06
-0.0699075, 3.16536e-06
-0.0599135, 3.2409899999999997e-06
-0.0499196, 3.3047399999999997e-06
-0.0399256, 3.3572399999999996e-06
-0.0299316, 3.4072399999999996e-06
-0.019938, 3.4584899999999997e-06
-0.00994404, 3.5066199999999997e-06
##END=$$ End of the data block

`;

export default cyclicVoltaJcamp2;
